export enum TimeseriesDisplayMode {
  line_chart = 'line_chart',
  table = 'table'
}
